export const divStyle = {
  border: '1px solid rgba(128, 128, 128, 0.293)',
  borderRadius: '5px',
  padding: '10px 10px 10px 0px'
};
export const styles = {
  marginBottom: 5
};
export const Daction = {
  textAlign: 'left',
  padding: '10px',
  gap: '5px',
  display: 'flex',
  flexDirection: 'column'
};
